import { render, staticRenderFns } from "./EmailAuthenticationUser.vue?vue&type=template&id=72ceafa4"
import script from "./EmailAuthenticationUser.vue?vue&type=script&lang=js"
export * from "./EmailAuthenticationUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports